export enum Area {
  ON = 'ON',
  BC = 'BC',
  CA = 'CA',
  AB = 'AB',
  US_CO = 'CO',
  US_CA = 'CA',
  US_FL = 'FL',
  US_WA = 'WA',
  AU_EST = 'AU_EST'
}
